import app from '$$app';
import ganttViewModel from '$$ganttViewModel';
import _ from 'lodash';
import projectsModel from '$$projectModel';
import customDaysTemplatesModel from '$$customDayTemplatesModel';
import userProjectConfigModel from '$$userProjectConfigModel';
import timeTracking from '$$timeTrackingModel';
import helpers from '../helpers';
import globalStore from "$$globalStore";
import constants from '$$helpers/constants';
import tasksHelpers from '$$store/tasks/helpers';

const getProjectDataFromServer = function (ganttId) {
  return webix.ajax()
    .get(`/api/collaboration/${ganttId}?${Date.now()}`);
};

const showCollaborationMessage = function (user) {
  helpers.notify({
    userPic: user.photo,
    locale: 'history_event_restored',
    data: {},
  });
};

const freezeOpenCloseState = function (ganttId, taskData) {
  const currentTasks = globalStore.getters['tasksModel/getItem'](ganttId)?.tasks;
  const data = taskData.tasks.data;

  _.each(data, nTask => {
    let compareTask = null;

    if (nTask.type === constants.TASK_TYPES.project) {
      compareTask = _.find(currentTasks, t => +t.id === +nTask.id);
    }

    if (compareTask && nTask.type === compareTask.type) {
      nTask.open = compareTask.open;
    }
  });

  return taskData;
};

const manualUpdateModels = function (projectData, responseData, ignoreUpdate, runAutoScheduling) {
  if (responseData.customDays) {
    customDaysTemplatesModel.manualAddTemplateToShareProject(responseData.customDays, projectData.gantt_id, 'collaboration');
  }

  if (responseData.resources) {
    globalStore.commit('resourcesModel/setData', responseData.resources, { root: true });
  }

  if (responseData.projectData) {
    projectData.config = responseData.projectData.config;
    projectData.name = responseData.projectData.name;
    projectData.last_update = responseData.projectData.last_update;
    projectData.config = userProjectConfigModel.getUserConfigByGanttIdAndMergeToProjectConfig(projectData.gantt_id, projectData.config);

    app.trigger('project-config:change', projectData.gantt_id, projectData.config);
  }

  if (responseData.globalCustomColumnsData) {
    globalStore.commit('columns/setCustomColumns', responseData.globalCustomColumnsData);
  }

  if (responseData.userCustomColumnsData) {
    globalStore.commit('columns/updateProject', {
      projectId: projectData.gantt_id,
      updated: { ...responseData.userCustomColumnsData },
    });
    app.trigger('userCustomColumnsModel:change', projectData.gantt_id, 'update');
  }

  if (responseData.timeTrackingData) {
    timeTracking.manualUpdateItem(responseData.timeTrackingData, projectData.gantt_id, 'collaboration');
  }

  if (responseData.taskData) {
    globalStore.commit('tasksModel/updateProjectTasksData', tasksHelpers.prepareProjectTasksData(freezeOpenCloseState(projectData.gantt_id, responseData.taskData)), { root: true });
  }

  projectsModel.manualLiveUpdate(projectData, ignoreUpdate, runAutoScheduling);
};

const hardRefresh = (event, ganttId) => getProjectDataFromServer(ganttId).then(rawResponseData => {
  const projectData = projectsModel.getItem(ganttId);

  if (!projectData) {
    return;
  }

  const ganttIDs = ganttViewModel.getGanttIDs();
  const responseData = rawResponseData.json();
  const isSameProjectOpen = _.includes(ganttIDs, +ganttId);

  manualUpdateModels(projectData, responseData, false, false);

  app.trigger('collaboration:updatedModels');

  if (isSameProjectOpen) {
    showCollaborationMessage(event.innerSettings.user);

    app.trigger('project-calendar:change', +ganttId);
    app.trigger('settings:days:collaboration', +ganttId);
  }
});

async function onHistoryRestored(event) {
  await hardRefresh(event, +event.data.data.projectId);

  app.trigger('onAfterCollaboration', {
    event: event.event,
    projects: [+event.data.data.projectId],
  });
}

export default onHistoryRestored;
